// FEAT-B — touch virtual joystick math. Pure: maps a finger offset (dx,dy) from the stick centre into a
// movement vector matching keyboard moveVector() conventions (x = right, z = forward where up/-y → -z),
// clamped to the unit circle with a small deadzone. Headless-testable; the DOM wiring lives in touchcontrols.

export interface Vec2 {
  x: number
  z: number
}

export function joystickVector(dx: number, dy: number, radius: number, deadzone = 0.18): Vec2 {
  const r = radius > 0 ? radius : 1
  let x = dx / r
  let z = dy / r // screen-down (dy>0) → +z (backwards), screen-up → -z (forward) — matches WASD
  const m = Math.hypot(x, z)
  if (m < deadzone) return { x: 0, z: 0 }
  if (m > 1) {
    x /= m
    z /= m
  }
  return { x, z }
}
